import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getProjectById } from "../utils/api";

export const fetchProjectById = createAsyncThunk(
  'project/fetchProjectById',
  async ({accessToken, id}, thunkAPI) => {
    const response = await getProjectById(accessToken, id);

    if (!response.data.success) {
      throw new Error('Failed to fetch project');
    }

    return response.data;
  }
);


const viewProjectSlice = createSlice({
  name: 'project',
  initialState: {
    projectData: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectData = action.payload.data[0];
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default viewProjectSlice.reducer;
